import { getDashboardData } from '@/dataProvider/dashboardDataProvider/getDashboardData';

export const dashboardDataProvider = {
  getDashboardData,
};
